import React, { useEffect, useRef, useState } from "react";
import classes from "./AdvancedFacilities.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { Autoplay, Pagination } from "swiper/modules";
import AdvancedCard from "./advanced-card/AdvancedCard";
import AdjustFontSize from "../../../components/adjust-font-size/AdjustFontSize";
import { repeatObjects } from "../../home-page/Branch-Carousel/BranchCarousel";

export const textasa = "hi";

const AdvancedFacilitiesList = ({ data }) => {
  const swiperRef = useRef(null);
  
  const [isAutoplayRunning, setIsAutoplayRunning] = useState(true);
  const divRef = useRef(null);
  const [widthValue, setWidthValue] = useState();
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();

  useEffect(() => {
    //html content will rearrange fontsize when window width changes
    if (data) {
      setResponsiveHtml(
        AdjustFontSize(
          data?.description, width
        )
      );
    }
  }, [data, width]);

  useEffect(() => {
    const calculateWert = () => {
      const vw = window.innerWidth; // Get the width of the viewport in pixels
      const result = 0.91 * vw - 100; // Perform the calculation
      setWidthValue(result); // Update the state
    };

    // Initial calculation
    calculateWert();

    // Recalculate on window resize
    window.addEventListener("resize", calculateWert);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", calculateWert);
    };
  }, []);

  const toggleAutoplay = () => {
    if (swiperRef.current) {
      if (isAutoplayRunning) {
        swiperRef.current.autoplay.stop(); // Stop autoplay
      } else {
        swiperRef.current.autoplay.start(); // Start autoplay
      }
      setIsAutoplayRunning(!isAutoplayRunning);
    }
  };

  console.log("width value is", widthValue);

  return (
    <div className={`${classes.outer}`}>
      <div className={`${classes.inner} bg-primary-500`}>
        <img src="/img/gallery-pattern.svg" alt="pattern" className={classes.pattern}></img>
        <div className={classes.innerContent}>
          <div
            className={classes.title}
            ref={divRef}
            data-aos="fade-down"
            data-aos-delay="200"
          >
            <h1 className="primary-300 bg-primary-200">{data?.subTitle}</h1>
            {data?.showTitle && (
              <div
                style={{
                  width: width < 769 && "88vw",
                  textAlign: width < 769 && "center",
                }}
              >
                <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
              </div>
            )}
            {/* <div className={`${classes.underLine} bg-secondary-200`}></div> */}
            {data?.description && (
            <h4
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: responsiveHtml }}
            ></h4>
          )}
          </div>
          <div className={classes.sliderOuter}>
            <div className={classes.arrowDiv}>
              <div className={classes.arrows}>
                <img
                  className={classes.leftArrow}
                  src="/img/arrow-left-white.svg"
                  alt="Prev"
                  onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
                />
                <img
                  src="/img/arrow-right-white.svg"
                  className={classes.rightArrow}
                  alt="Next"
                  onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
                />
              </div>
            </div>
            <div className={`${classes.swiperOuter} outer-outer`}>
              <div>
                {/* Custom Navigation Arrows */}

                {/* Swiper */}
                <Swiper
                  //   modules={[Navigation, Pagination]}
                  slidesPerView={
                    width > 1800 ? 5 : width > 1200 ? 4 : width > 600 ? 3 : 1
                  } // Show 3 images at a time
                  modules={[Autoplay]}
                  // speed={5000}
                  autoplay={{
                    delay: 3000, // 3 seconds
                    disableOnInteraction: false, // Autoplay continues even after interaction
                  }}
                  spaceBetween={20} // Add space between slides
                  onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
                  pagination={{ clickable: true }} // Enable clickable dots
                  loop={true} // Enable infinite looping
                  draggable={true} // Enable drag/swipe functionality
                >
                  {repeatObjects(data?.listingItems[0]?.images,6)?.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <AdvancedCard data={slide} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedFacilitiesList;
